<template>
  <div class="investment-section">
    <Heading :level="1">{{ title }}</Heading>

    <InvestmentSectionLoader v-if="isLoading" />
    <template v-else>
      <slot name="subtitle" />

      <div class="investment-section__balance-group">
        <slot name="default" />

        <div class="investment-section__actions">
          <slot name="actions" />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Heading } from '@warrenbrasil/nebraska-web';
import InvestmentSectionLoader from './components/InvestmentSectionLoader.vue';

@Component({
  components: { Heading, InvestmentSectionLoader }
})
export default class InvestmentSection extends Vue {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Boolean, required: true })
  private isLoading!: boolean;
}
</script>

<style lang="less" scoped>
.investment-section {
  &__balance-group {
    margin-top: @size-spacing-x500;
  }

  &__actions {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    > button {
      border-radius: 0;
      margin-top: 1px;
      min-height: 56px;
    }
  }

  @media (min-width: 30em) /* 480px */ {
    &__balance-group {
      margin-top: @size-spacing-x1100;
    }

    &__actions {
      position: initial;
      flex-direction: row;
      margin-top: @size-spacing-x500;

      > button {
        min-width: 220px;
        min-height: unset;
        border-radius: 8px;
      }
    }
  }
}
</style>
